import script from "./RegisterModel.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModel.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModel.vue?vue&type=style&index=0&id=750f9599&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750f9599"]])

export default __exports__